function ChartSkeleton({ height = 240 }: { height?: number }) {
  return (
    <div
      className="animate-pulse rounded-lg bg-zt-bg"
      style={{ height }}
      aria-hidden="true"
    />
  );
}

export default ChartSkeleton;
